import { Img } from "../../../../layout/Img"

export const TestimonialRows = ({ testimonials }) => {
  return (
    <div className="container flex flex-row items-center justify-center w-11/12 mx-auto mb-20 md:w-10/12">
      <div className="grid grid-cols-1 gap-10 pt-10 sm:grid-cols-2 md:grid-cols-3">
        {testimonials.map((item) => (
          <div
            className="flex flex-col items-center justify-center"
            key={item.uid}
          >
            <div className="flex flex-col">
              <Img
                className="flex justify-center w-48 h-48 mx-auto rounded-full"
                image={item.profilePicture[0]}
                
                imgStyle={{ borderRadius: '100%' }}
              />
              <div
                className="mx-auto mt-4 font-light text-center text-secondary"
                dangerouslySetInnerHTML={{ __html: item.quote }}
              />

              <p className="pt-4 mx-auto text-sm font-light text-center">
                {`${item.title}, ${item.profileRole}`}
              </p>
              <p className="pt-2 mx-auto text-sm font-semibold text-center">
                {item.sponsor[0].title}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
